<template>
  <div class="home-main">
    <div class="header">
      <img style="width:524px; height: 224px;" src="img/logo.svg" alt class="icon-img" />
      <img style="height:478px; width: 1170px" class="filter-img" />
      <img
        style="height:478px; width: 1170px"
        class="img-fluid home-img"
        src="img/banner.png"
        alt="home-img"
      />
    </div>
    <i style="z-index: 0; margin-left: 50px" class="fas fa-quote-left quotet"></i>
    <div class="home-content">
      
      <p style="font-style: italic; text-align: justify; font-size: 20px; font-weight: lighter;">
        <strong v-html="texto">
       
    </strong>
      </p>
      

      <div class="bordert"></div>
      <div style="align-items: center; justify-content: center;" class="cardst">
        <div
          v-b-toggle.collapse-a
          @click="geral = !geral, domestico=false;"
          class="cardt geral"
          :class="{'hidden':geral}"
        >
          <i class="fas fa-user-circle cardt-img"></i>
          <p>
            Empregadores em Geral
            <br />(CNPJ e CAEPF)
          </p>
          <div class="wrow"></div>
          <i v-if="!geral" class="fas fa-caret-down cardt-arrow"></i>
          <i v-else style="font-size: 35px" class="fas fa-minus cardt-arrow"></i>
          <b-collapse accordion="my-accordion" id="collapse-a" class="mt-2">
            <router-link :to="{name:'ReducaoGeral'}">
              <div class="hidden-btn">
                <i class="fas fa-arrow-circle-down hidden-icon"></i>
                <p>
                  Redução da jornada
                  <br />de trabalho e de salários
                </p>
                <i class="fas fa-caret-right hidden-icon2"></i>
              </div>
            </router-link>
            <router-link :to="{name:'SuspensaoGeral'}">
              <div class="hidden-btn">
                <i class="fas fa-times-circle hidden-icon"></i>
                <p>Suspensão do contrato de trabalho</p>
                <i class="fas fa-caret-right hidden-icon2"></i>
              </div>
            </router-link>
          </b-collapse>
        </div>
        <!-- <div
          v-b-toggle.collapse-b
          @click="domestico = !domestico, geral = false"
          class="cardt domestico"
          :class="{'hidden':domestico}"
        >
          <i class="fas fa-user-circle cardt-img"></i>
          <p style="margin-bottom: 135px;">Empregadores Domésticos</p>
          <div class="wrow"></div>
          <i v-if="!domestico" class="fas fa-caret-down cardt-arrow"></i>
          <i v-else style="font-size: 35px" class="fas fa-minus cardt-arrow"></i>
          <b-collapse accordion="my-accordion" id="collapse-b" class="mt-2">
            <router-link :to="{name:'ReducaoDomestico'}">
              <div class="hidden-btn">
                <i class="fas fa-arrow-circle-down hidden-icon"></i>
                <p>
                  Redução da jornada
                  <br />de trabalho e de salários
                </p>
                <i class="fas fa-caret-right hidden-icon2"></i>
              </div>
            </router-link>
            <router-link :to="{name:'SuspensaoDomestico'}">
              <div class="hidden-btn">
                <i class="fas fa-times-circle hidden-icon"></i>
                <p>Suspensão do contrato de trabalho</p>
                <i class="fas fa-caret-right hidden-icon2"></i>
              </div>
            </router-link>
          </b-collapse> 
        </div> -->
      </div>
      
      
    </div>
   
  </div>
</template>

<script>
import api from '../services/api.js'
export default {
  methods: {},
  computed: {},
  watch: {},
  data() {
    return {
      geral: false,
      domestico: false,
      texto:''    
    };
  },
  async  created() {
    
    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
     this.texto =  await api.getTextoInicial()   
  },
  mounted() {
    this.$modal.show("welcome");
  }
};
</script>

<style>
* {
  font-family: "Segoe UI";
}

ul li {
  list-style-type: disc !important;
}

ul li::before {
  color: black;
}

.flex-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px 0 20px 0;
}

.bordert {
  border-bottom: 1px solid rgb(0, 0, 0, 0.35);
  margin: 80px 0;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-img {
  z-index: 1;
  position: relative;
  object-fit: cover;
  filter: brightness(90%) contrast(200%);
}

.filter-img {
  z-index: 2;
  position: absolute;
  background: #f7b733;
  filter: opacity(50%) brightness(90%) contrast(100%);
}

.icon-img {
  transition: all 0 2s ease;
  z-index: 3;
  position: absolute;
  width: 350px;
  margin-top: 50px;
}

.home-content {
  align-self: center;
  margin: 20px 90px 0 90px;
}

.home-content p {
  font-size: 40px;
  text-align: left;
  font-weight: 700;
  font-style: italic;
  line-height: 35px;
  padding: 0 0 15px 0;
  margin: 85px 0 10px 0;
  color: #565656;
}


.cardst {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 15px 0 100px 0;
}

.cardt {
  width: 475px;
  background: #f7b733;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 10px 0 10px;
  cursor: pointer;
  border-radius: 10px;
}

.geral {
  height: 381px;
}

.domestico {
  height: 381px;
}

.cardt-img {
  margin: 25px 0 25px 0;
  font-size: 76px;
  color: #fff7e6;
  flex: 1;
}

.cardt p {
  font-size: 35px !important;
  text-align: center;
  color: #fff7e6;
  flex: 1;
  margin: 0 0 100px 0;
}

.cardt .wrow {
  width: 400px;
  border: 0.5px solid #fff7e6;
  margin: 0 0 20px 0;
  background: #fff7e6;
}

.cardt-arrow {
  color: #fff7e6;
  font-size: 50px;
}

.hidden {
  height: 100% !important;
}

.hidden-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 400px;
  height: 80px;
  border: 1px solid #fff7e6;
  border-radius: 5px;
  margin: 20px;
}

.hidden-btn p {
  font-size: 20px !important;
  margin: 10px 0 0 0 !important;
  line-height: 30px;
}

.hidden-btn2 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 400px;
  height: 80px;
  border: 1px solid #fff7e6;
  border-radius: 5px;
  margin: 20px;
}

.hidden-btn2 p {
   font-size: 15px !important;
    margin: 15px 25px !important;
   line-height: 30px;

}

.hidden-icon {
  color: #fff7e6;
  font-size: 35px;
  margin-left: 15px;
}

.hidden-icon2 {
  color: #fff7e6;
  font-size: 40px;
  margin-right: 15px;
}

/* !!!!!!!!!!!!!!!!!!!!!!!!!!!style outras paginas!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */

.input input {
  width: 400px;
  height: 40px;
  margin-bottom: 50px !important;
  display: block;
  border: 1px solid #707070;
  border-radius: 7px;
  padding-left: 10px;
}

.calcular-btn {
  width: 172px;
  height: 48px;
  background: #ff7835;
  border-radius: 5px;
  color: #fff7e6;
  font-size: 24px;
  font-style: italic;
}

.limpar-btn {
  width: 105px;
  height: 39px;
  border: 2px solid #ff7835;
  color: #383838;
  border-radius: 5px;
  font-size: 17px;
  font-style: italic;
  font-weight: 500;
  margin-right: 50px;
}

.resultado {
  width: 100%;
  background: #bebebe;
}

.obs {
  width: 90%;
  border: 1px solid #707070;
  border-radius: 10px;
  margin: 10px 0 0 0;
}

.voltar-btn {
  width: 153px;
  height: 62px;
  border: 2px solid #ff7835;
  font-size: 28px;
  color: #383838;
  font-weight: 700;
  border-radius: 5px;
  font-style: italic;
  margin-top: 105px;
}

.voltar-btn:hover {
  background: #ff7835;
  color: #fff7e6;
}

.limpar-btn:hover {
  background: #ff7835;
  color: #fff7e6;
}

.calcular-btn:hover {
  background: rgb(196, 81, 24);
}

.question-icon {
  position: relative;
  color: #f7b733;
  font-size: 18px;
  top: -80px;
  left: 415px;
}

.quotet {
  position: absolute;
  top: 625px;
  font-size: 85px;
  color: #f7b733;
  opacity: 0.2;
}
</style>